// src/components/AdminDashboard.jsx
import React, { useState } from "react";
import { FaSearch, FaUserCircle } from "react-icons/fa";
import { getRequest } from "../helpers/api.helper";
import { useNavigate } from "react-router-dom";
import { UPLOAD_URL } from "../utils/constants";
import {
  getPrivacyOverlayLabel,
  shouldBlurProfileImage,
} from "../utils/imagePrivacy";
const SearchById = () => {
  const [matrimonyId, setMatrimonyId] = useState("");
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState<any>(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSearch = async () => {
    const normalizedId = matrimonyId.trim().toUpperCase();

    if (!normalizedId) {
      setError("Please enter a Matrimony ID.");
      return;
    }

    setError("");
    setLoading(true);
    setProfile(null);

    try {
      const response = await getRequest(`/bureau/profile/${normalizedId}`);
      if (response.success) {
        setProfile(response.data);
      } else {
        setError("No profile found for this Matrimony ID.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="w-full max-w-md bg-white shadow-md rounded-lg p-6">
      <div className="flex flex-col sm:flex-row items-end gap-3">
        <div className="w-full">
          <label className="block text-green-700 text-sm font-medium mb-1">
            Enter Matrimony ID
          </label>
          <input
            type="text"
            placeholder="Eg: T123456"
            value={matrimonyId}
            onChange={(e) => setMatrimonyId(e.target.value.toUpperCase())}
            className="w-full border-2 border-green-500 rounded-md px-4 py-2 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-green-400 focus:outline-none"
          />
        </div>

        <button
          onClick={handleSearch}
          disabled={loading}
          className={`flex items-center gap-2 px-6 py-2 rounded-md text-white font-semibold transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700"
          }`}
        >
          <FaSearch size={25} />
        </button>
      </div>

      {/* Error Message */}
      {error && (
        <p className="text-red-600 text-sm font-medium mt-2 text-start">
          {error}
        </p>
      )}
      {/* Profile Result */}
      {profile && (
        <div className="mt-8 border-t pt-6">
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden">
              {profile.image ? (
                (() => {
                  const blurPhoto = shouldBlurProfileImage(
                    profile.imagePrivacy
                  );
                  return (
                    <div className="relative w-full h-full">
                      <img
                        src={UPLOAD_URL + "/users/profile_pic/" + profile.image}
                        alt={profile.fullName}
                        className={`w-full h-full object-cover ${
                          blurPhoto ? "blur-sm scale-110 brightness-90" : ""
                        }`}
                      />
                    </div>
                  );
                })()
              ) : (
                <FaUserCircle className="text-gray-400 text-5xl" />
              )}
            </div>

            <div className="flex-1 text-center sm:text-left">
              <h3 className="text-lg font-semibold text-gray-800">
                {profile.fullName}
              </h3>
              <p className="text-gray-600 text-sm">
                Matrimony ID:{" "}
                <span className="font-semibold text-gray-800">
                  {profile.martialId}
                </span>
              </p>
              <p className="text-gray-600 text-sm">
                Age: {profile.age} | Caste: {profile.caste}
              </p>
              <p className="text-gray-600 text-sm">
                Location: {profile.city || ""}, {profile.state || ""}
              </p>

              <button
                className="mt-3 bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md text-sm font-semibold transition"
                onClick={() =>
                  navigate(`/admin/profile/detail/${profile.martialId}`)
                }
              >
                View Full Profile
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchById;
